export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10306.6279b3e8.jpg";